<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Consulta de comprobantes electrónicos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="consultarComprobantes" class="btn-info btn--bigger">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
          <button @click="exportar" class="btn-success btn--bigger"><i class="fa fa-file-excel-o"></i> <span>Exportar</span></button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Información de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="seleccionarEmpresa"
                  :options="empresas"
                  label="descripcion"
                  id="empresa"
                  placeholder="Seleccione..."
                  v-model="selectedEmpresa"
                ></v-select>
                <label for="empresa">Empresa</label>
                <span v-if="errores.id_empresa" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.id_empresa[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-8">
            <div class="form-inline">
              <label for="hoy">
                <input v-model="form.tipoFecha" type="radio" id="hoy" value="H" />
                <span>Hoy</span>
              </label>
              <label for="ayer">
                <input v-model="form.tipoFecha" type="radio" id="ayer" value="A" />
                <span>Ayer</span>
              </label>
              <label for="personalizada">
                <input v-model="form.tipoFecha" type="radio" id="personalizada" value="P" />
                <span>Personalizada</span>
              </label>
              <div v-show="form.tipoFecha === 'P'" class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.desde"
                    locale="es"
                    no-label
                    only-date
                    auto-close
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione una fecha..."
                  />
                  <label for="desde">Desde</label>
                  <span v-if="errores.desde" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.desde[0] }}</strong>
                  </span>
                </div>
              </div>
              <div v-show="form.tipoFecha === 'P'" class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="hasta"
                    v-model="form.hasta"
                    locale="es"
                    no-label
                    only-date
                    auto-close
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione una fecha..."
                  />
                  <label for="desde">Hasta</label>
                  <span v-if="errores.hasta" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.hasta[0] }}</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                v-model="form.numero_documento"
                v-mask="'###-###-#########'"
                id="numeroComprobante"
                placeholder="###-###-########"
              >
                <span>Número de comprobante</span>
              </input-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-xs-12">
        <div class="card">
          <div class="card__title">
            <h5>Resultados de la consulta</h5>
          </div>
          <div class="card__content">
            <div class="table-responsive mt-3">
              <table>
                <thead>
                  <tr>
                    <th>Tipo de comprobante</th>
                    <th>Fecha de emisión</th>
                    <th>Número de comprobante</th>
                    <th>Total sin impuestos</th>
                    <th>Impuestos</th>
                    <th>Descuento</th>
                    <th>Total</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="comprobantes.length === 0">
                    <td colspan="8">
                      <strong>No se ha encontrado resultados.</strong>
                    </td>
                  </tr>
                  <tr v-for="(comprobante, index) in comprobantes" :key="index">
                    <td>{{ comprobante.tipo_comprobante.descripcion }}</td>
                    <td>{{ comprobante.fecha_emision_comprobante }}</td>
                    <td>{{ comprobante.numero_documento }}</td>
                    <td>
                      $ {{ (comprobante.total_sin_impuestos !==
                      null)?parseFloat(comprobante.total_sin_impuestos).toLocaleString(locale):0 }}
                    </td>
                    <td>$ {{ (comprobante.total_impuestos !== null)?parseFloat(comprobante.total_impuestos):0.00 }}</td>
                    <td>$ {{ (comprobante.total_descuento !== null)?parseFloat(comprobante.total_descuento):0.00 }}</td>
                    <td>$ {{ parseFloat(comprobante.valor_total).toLocaleString(locale) }}</td>
                    <td class="table-actions">
                      <a
                        target="_blank"
                        :href="url + '/comprobantes/' + comprobante.id_comprobante + '/ride?empresa_id=' + (empresaConsultada !== ''?empresaConsultada:'')"
                        class="btn-light btn--text"
                      >
                        <i class="fa fa-eye"></i>
                      </a>
                      <a
                        target="_blank"
                        :href="url + '/comprobantes/' + comprobante.id_comprobante + '/xml'"
                        class="btn-info btn--text"
                      >
                        <i class="fa fa-download"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tipoFecha: {
      type: String,
      required: false,
      default: "H"
    }
  },
  data: function() {
    return {
      form: {
        tipoFecha: this.tipoFecha,
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        id_empresa: "",
        tipo_reporte: 'N'
      },
      errores: {
        tipoFecha: undefined,
        desde: undefined,
        hasta: undefined,
        id_empresa: undefined
      },
      selectedEmpresa: null,
      comprobantes: [],
      url: url,
      empresas: [],
      locale: locale,
      empresaConsultada: ""
    };
  },
  methods: {
    serialize : function ( obj ) {
        return '?'+Object.keys(obj).reduce(function(a,k) {
          let val = obj[k];
          let esArray = false;
          if (val instanceof Date){
            val = val.toLocaleDateString('en');
          }else if(val instanceof Array){
            esArray = true;
            let acumulador='';
            for(let i=0; i< val.length; i++){
              acumulador+= k + '%5B%5D=' + val[i];
              if(i!=val.length-1){
                acumulador+='&';
              }
            }
            val=acumulador;
            a.push(val);
          }
          if (!esArray)   
            a.push(k+'='+encodeURIComponent(val));
          return a;
        },[]).join('&')
    },
    exportar: function () {
      this.form.tipo_reporte = 'E';
      let urlApi = url + '/portal-cautivo/comprobantes' + this.serialize(this.form);
      window.open(urlApi, '_blank');
    },
    cargarDatosFormulario: function() {
      let that = this;
      axios.get(this.url + "/portal-cautivo/datos").then(function(response) {
        that.empresas = response.data.empresas;
        that.selectedEmpresa = response.data.empresaActual;
        that.seleccionarEmpresa();
        that.consultarComprobantes();
      });
    },
    consultarComprobantes: function() {
      this.form.tipo_reporte = 'N';
      let that = this;
      that.errores = {};
      axios
        .post(this.url + "/portal-cautivo/comprobantes", this.form)
        .then(function(response) {
          that.empresaConsultada = that.form.id_empresa;
          that.comprobantes = response.data;
        })
        .catch(function(error) {
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              if (response.status === 422) {
                swal(
                  "Hay validaciones por corregir en el formulario.",
                  "Mensaje",
                  "warning"
                );
                that.errores = response.data.errors;
              }
            }
          }
        });
    },
    seleccionarEmpresa: function() {
      if (this.selectedEmpresa !== null)
        this.form.id_empresa = this.selectedEmpresa.id;
      else this.form.id_empresa = "";
    }
  },
  mounted: function() {
    this.cargarDatosFormulario();
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/portal-cautivo/ConsultaComprobantes.vue